import { render } from "./ShowBenefitComponent.vue?vue&type=template&id=65ba50b9&scoped=true"
import script from "./ShowBenefitComponent.vue?vue&type=script&lang=js"
export * from "./ShowBenefitComponent.vue?vue&type=script&lang=js"

import "./ShowBenefitComponent.vue?vue&type=style&index=0&id=65ba50b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ba50b9"]])

export default __exports__